import { useState, useEffect } from "react";
import { fetchLeads } from "@/api/leads";
import { errorToast } from "@/lib/toast";
import { useAuth } from "./use-auth";

export const useLeads = () => {
    const { astrologer } = useAuth();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    const getLeads = async () => {
        setLoading(true);
        try {
            const { status, data } = await fetchLeads({
                astrologerId: astrologer.astrologerId,
                accessToken: astrologer.accessToken,
            });
            if (status === 200) {
                setLeads(data.data?.leads);
                // Backend returns pagination.totalItems (see getLeadsByAstrologer).
                // The old field name `totalDocuments` was wrong and silently
                // produced undefined here, so the "All" tile always showed 0.
                setTotalItems(data.data?.pagination?.totalItems ?? 0);
            } else {
                errorToast("Failed to fetch leads");
            }
        } catch (err) {
            errorToast("An error occurred while fetching leads");
        } finally {
            setLoading(false);
        }
    };

    // Splice an updated lead in place so an edit doesn't require a full
    // refetch. The detail pane fires this after a successful PUT — keeps
    // the list card's status/classification badges in sync with the
    // pane on the next render.
    const updateLeadLocally = (updated) => {
        if (!updated?._id) return;
        setLeads((prev) =>
            (prev || []).map((l) => (l._id === updated._id ? { ...l, ...updated } : l))
        );
    };

    useEffect(() => {
        if (astrologer?.astrologerId) {
            setLeads([]);
            getLeads();
        }
    }, [astrologer?.astrologerId]);

    return { leads, loading, totalItems, getLeads, updateLeadLocally };
}